import type { TranslationKey } from '@/types/i18n.types';

/**
 * Traduce in chiave i18n il codice errore della edge function di pagamento, sul link
 * pubblico.
 *
 * I codici tornati dal server sono identificatori stabili, non testo da mostrare: quello
 * che il cliente legge lo decide qui. Sta in un file suo perche' lo usano sia l'header
 * (CTA sul totale) sia il pannello delle rate, e le due devono dire la stessa cosa.
 *
 * `itinerary_already_paid` arriva dal guard server sul doppio pagamento: e' l'ultima
 * difesa quando il cliente riapre una scheda vecchia su un viaggio gia' saldato. Va
 * spiegato, non lasciato cadere nell'errore generico.
 *
 * `payment_already_processing` non esiste piu' dal 2026-08-25: un tentativo ancora aperto
 * non impedisce di ripagare, il cliente vede un avviso e il pulsante resta attivo.
 */
export const sharedPaymentErrorKey = (error?: string | null): TranslationKey => {
    switch (error) {
        case 'stripe_not_configured':
            return 'sharedProposal.paymentNotAvailable';
        case 'stripe_not_allowed':
            return 'sharedProposal.payment.stripeNotAllowed';
        case 'itinerary_already_paid':
            return 'sharedProposal.payment.alreadyPaid';
        // Il pulsante e' gia' disabilitato finche' la spunta manca: qui si arriva solo
        // se i testi legali sono cambiati mentre la pagina era aperta. Ricaricare e'
        // davvero quello che il cliente deve fare.
        case 'legal_not_accepted':
            return 'sharedProposal.payment.legalNotAccepted';
        default:
            return 'sharedProposal.paymentError';
    }
};
